import React, { Suspense, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faUserSecret } from "@fortawesome/free-solid-svg-icons";
import "./PillButton.css";
import { radioClasses } from "@mui/material";
import DynamicIcon from "./DynamicIcon";

/**

### Props
- handleInput(required): function from parent called whenever vote type changes
- className(optional): classes that apply to the wrapper div of the object
- style(optional): styles that apply to the wrapper div of the object
- options(required): the choices that are possible for this button
- options(required): the choice that is currently selected

### Example
```jsx
const [options, setOptions] = useState({});
const choices = ["Majority + 1", "2/3", "Poll", "Non"];
// ...

<PillButton options={choices} chosen={options.voteType} handleInput={(choice) => setOptions({...options, voteType: choice})}/>
```
*/

const PillButton = ({ className, style, options, chosen, handleInput }) => {
    

    const summonPillButtons = () => {
        return options.map((option, index) => {
            const {pushButton, pushIcon, pushLabel} = option.text === chosen ? {
                pushButton: "pushedButton",
                pushIcon: "pushedButtonIcon",
                pushLabel: "pushedButtonLabel"
            } : {
                pushButton: "unpushedButton",
                pushIcon: "unpushedButtonIcon",
                pushLabel: "unpushedButtonLabel"
            };
            
            const topRight = index === 1 ? "12px" : "0px";
            const topLeft = index === 0 ? "12px" : "0px";
            const bottomRight = index + 1 >= options.length ? "12px" : "0px";
            const bottomLeft = (index + 1 >= options.length
                || index === options.length - 2) && index % 2 === 0 ? "12px" : "0px";
            const borderStyle = {
                borderRadius: `${topLeft} ${topRight} ${bottomRight} ${bottomLeft}`,
            };
            return (
                <div
                    key={index}
                    className={`pill-button ${pushButton}`}
                    style={borderStyle}
                    onClick={() => handleInput(option.text)}
                >
                    {option.icon ? (
                        <DynamicIcon className={pushIcon} iconName={`voteTypes/${option.icon}.svg`}/>
                    ) : null}
                    <div className={pushLabel}>{option.displayText ? option.displayText : option.text}</div>
                </div>
            );
        });
    };
    return (
        <div className={`pill-button-container ${className}`} style={style}>
            {summonPillButtons()}
        </div>
    );
}
export default PillButton;
